import { getApi } from 'common/api-common'
import { blobbyStrings } from './strings'
import { Format } from 'common/utils/format'

// Export for use in other components - directly format here to avoid initialization issues
export const tideCashBackAmount = Format.moneyShort(7500)

const defaultContent = {
  forTheOfferTerms: "for the Offer T&C's",
  offerTermsAndConditions: "Offer T&C's",
  seoBusinessBankingDescription: `Open a free business bank account in minutes and get ${tideCashBackAmount} cashback with Tide!`,
  seoBusinessBankingTitle:
    'A free business bank account in minutes | Hoxton Mix',
  tideCashBackAmount: tideCashBackAmount,
}
export const businessBankingStrings = getApi().makeStrings({
  en: defaultContent,
  es: blobbyStrings(defaultContent),
})
